// extracted by mini-css-extract-plugin
export default {"thread":"ticketThread_thread__MPRBf","composer":"ticketThread_composer__toL6j"};